export default {
  props: {
    loginErrorVisible: {
      type: Boolean,
      default: false
    },
    contactWay: {
      type: Object,
      default: () => ({})
    },
    cancellationTime: {
      type: String,
      default: ''
    }
  },
  computed: {
    visible: {
      get() {
        return this.loginErrorVisible;
      },
      set(val) {
        this.$emit('update:loginErrorVisible', val);
      }
    }
  },
  data() {
    return {};
  }
};